import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SuperAdminService } from '@core/services/super-admin.service';
import { NavigationExtras, Router } from '@angular/router';
import { DEFAULT_LOGO } from 'src/app/shared';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CompanyService } from 'src/app/shared/services/company.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-owner-list',
  templateUrl: './owner-list.component.html',
  styleUrls: ['./owner-list.component.scss']
})
export class OwnerListComponent implements OnInit{
  readonly destroyRef = inject(DestroyRef);
  value: string | any;
  value1: number = 10;
  companyList: any[];
  noRecordFound: boolean = false;
  selectedSortValue: number = 1;
  dummy = DEFAULT_LOGO;
  search: string = '';
  items: any;
  currentDate = new Date();
  selectedCompanyId = null;
  onCompanyChange : boolean = false;

  constructor(private readonly service: SuperAdminService, private readonly route: Router, private readonly ref: DynamicDialogRef, private readonly companyService: CompanyService, public config: DynamicDialogConfig, private readonly encryptStorage: EncryptionStorageService) { }
  ngOnInit() {
    this.onCompanyChange = this.config?.data?.onCompanyChange;
    this.selectedCompanyId= this.encryptStorage.getItem("companyId") ?? null;
    this.getCompanyList();
    this.getSortingValue();
  }

  getSortingValue() {
    this.items = [
      { label: 'Alphabetical - Asc', value: 1 },
      { label: 'Alphabetical - Desc', value: 2 },
      { label: 'Highest Occupancy  %', value: 3 },
      { label: 'Lowest Occupancy %', value: 4 },
      { label: 'Highest number of parking lots', value: 5 },
      { label: 'Lowest number of parking lots', value: 6 }
    ];
  }

  handleSearchChange() {
    const trimmedSearch = this.search.trim();
    if (trimmedSearch.length === 0 || trimmedSearch.length > 3) {
      this.getCompanyList();
    }
  }

  getCompanyList(): void {
  const searchPayload = {
    search: this.search,
    sort: this.selectedSortValue,
    isOccupancyRequired: true
  };

  this.service.getCompanyList(searchPayload)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: (response: any) => {
        this.companyList = response;
      },
      error: () => {
        this.noRecordFound = true;
        this.companyList = [];
      }
    });
}

  setSelectedCompany(companyId) {
    this.encryptStorage.setItem('companyId', companyId);
  }

navigate(id: string,name: string) {

      const companyId = id === ""? this.encryptStorage.getItem("companyId") || this.companyList[0].id: id;
      const companyName = name === ""? this.encryptStorage.getItem("companyName") || this.companyList[0].name : name;
      this.companyService.setCompanyId(companyId);
      this.encryptStorage.setItem('companyId', companyId);
      this.encryptStorage.setItem('companyName', companyName);
      const currentRoute = this.route.url;
      const basePath = this.getBasePath(currentRoute);
      const navigationPath = `${basePath}${companyId ? `/${companyId}` : ''}`;
      const navigation: NavigationExtras = {
        state: {
         onCompanyChange: this.onCompanyChange ?? false,
        },
      }; 
      if (basePath) {
        this.route.navigate([navigationPath], navigation);
      }
      this.ref.close();
  
}
getBasePath(currentRoute: string): string | null {
  const routes = [
    'super-admin/dashboard',
    'super-admin/bookings',
    'super-admin/parking-list',
    'super-admin/assisted-booking-list',
    'super-admin/financial',
    'super-admin/invoice',
    'super-admin/group-booking-list',
    'super-admin/create-offer',
    'super-admin/survey-list'
  ];
  for (const route of routes) {
    if (currentRoute.includes(route)) {
      return route;
    }
  }
  return null;
}

cancelDialog(): void {
  this.navigate("","");
  this.ref.close();
}

}

